import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { OrderInQueue } from 'app/models/orderInQueue.model';
import { OrdersState } from 'app/state-management/states/orders.states';
import {firstValueFrom, Observable } from 'rxjs';
import { NoOrdersId } from 'app/models/orderFilter.model';

@Component({
  selector: 'app-order-list-redirect',
  templateUrl: './order-list-redirect.component.html',
  styleUrls: ['./order-list-redirect.component.scss'],
})
export class OrderListRedirectComponent implements OnInit {

  @Select(OrdersState.ordersList) ordersList$: Observable<OrderInQueue[]>;

  constructor(
    public store: Store,
    private router: Router,
    public activatedRoute: ActivatedRoute
  ) {
  }

  async ngOnInit(): Promise<void> {
    let currentOrderId = NoOrdersId;

    const [ordersList, params] = await Promise.all([
      firstValueFrom(this.ordersList$),
      firstValueFrom(this.activatedRoute.params)]);

    if (ordersList.length) {
      let foundOrder: OrderInQueue;
      if (params.id) {
        foundOrder = ordersList.find(o => o.id === params.id);
      }
      if (!foundOrder) {
        let orderToRedirect: OrderInQueue;
        if (ordersList.length > 0) {
          orderToRedirect = ordersList[0];
        }
        if (orderToRedirect) {
          currentOrderId = orderToRedirect.id;
        }
      }
    }

    await this.router.navigate(['./', currentOrderId], {
      relativeTo: this.activatedRoute,
      state: {
        ordersReceivedAndRedirected: true,
      },
    });
  }
}
